{
  "tabs": {
    "chat": "ჩათი",
    "reminders": "გახსენება",
    "calendar": "კალენდარი",
    "settings": "პარამეტრები"
  },
  "common": {
    "cancel": "გაუქმება",
    "save": "შენახვა",
    "confirm": "დადასტურება",
    "delete": "წაშლა",
    "back": "უკან",
    "close": "დახურვა",
    "edit": "რედაქტირება",
    "search": "ძიება",
    "all": "ყველა",
    "loading": "იტვირთება...",
    "error": "შეცდომა მოხდა",
    "notFound": "არ მოიძებნა",
    "tryAgain": "გთხოვთ, სცადეთ კიდევ",
    "retry": "გაიმეორეთ",
    "undo": "გაუქმება",
    "pullToRefresh": "გაახლებას ჩაატარეთ",
    "justNow": "ახლახან"
  },
  "auth": {
    "welcome": "კეთილი იყოს თქვენი მობრძანება FishMemory-ში",
    "tagline": "თქვენი WhatsApp-ის შეხსენების ასისტენტი, ახლა თქვენს ჯიბეში.",
    "subtitle": "თქვენი WhatsApp-ის შეხსენების ასისტენტი, ახლა თქვენს ჯიბეში.",
    "phoneLabel": "თქვენი WhatsApp ნომერი",
    "phoneHint": "WhatsApp-ით გაგზავნით ვერიფიკაციის კოდს",
    "invalidPhone": "გთხოვთ, შეიყვანეთ ვალიდური ტელეფონის ნომერი",
    "continue": "გაგრძელება",
    "enterPhone": "შეიყვანეთ თქვენი WhatsApp ნომერი",
    "phonePlaceholder": "ტელეფონის ნომერი",
    "sendCode": "კოდის გაგზავნა",
    "verifyTitle": "ნომრის ვერიფიკაცია",
    "otpSentTo": "6-ნიშნა კოდი გაგზავნილია {{phone}} WhatsApp-ით",
    "enterFullCode": "გთხოვთ, შეიყვანეთ ყველა 6 ციფრი",
    "invalidOtp": "არასწორი კოდი. გთხოვთ, სცადეთ ისევ.",
    "otpFailed": "კოდის გაგზავნა ვერ მოხერხდა. სცადეთ ისევ.",
    "otpResent": "კოდი ხელახლა გაგზავნილია",
    "resendIn": "ხელახლა გაგზავნა {{seconds}} წამში",
    "resendCode": "კოდის ხელახლა გაგზავნა",
    "enterOtp": "შეიყვანეთ WhatsApp-ით გაგზავნილი კოდი",
    "verify": "ვერიფიკაცია",
    "resend": "კოდის ხელახლა გაგზავნა",
    "wrongNumber": "არასწორი ნომერი?",
    "backToPhone": "უკან ნომერზე",
    "editPhone": "ნომრის რედაქტირება",
    "error": "შეცდომა",
    "setupTitle": "მოდით დავაყენოთ",
    "setupSubtitle": "ასპარეზებს შეგიძლიათ შეცვალოთ პარამეტრებში ნებისმიერ დროს",
    "namePlaceholder": "თქვენი სახელი",
    "letsGo": "დასრულება",
    "skipForNow": "ახლა გამოტოვება"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "დაწერეთ შეტყობინება...",
    "inputPlaceholder": "დაწერეთ შეტყობინება...",
    "typing": "FishMemory წერს...",
    "online": "ონლაინში",
    "connecting": "კავშირის დამყარება...",
    "reconnecting": "კავშირის აღდგენა...",
    "offline": "ოფლაინში",
    "empty": "დაიწყეთ საუბარი",
    "emptyHint": "შექმენით შეხსენებები, შეამოწმეთ განრიგი ან დახმარება ითხოვეთ.",
    "emptyAction": "გაგზავნეთ ნიმუშის შეხსენება",
    "actions": "ჩეთის მოქმედებები",
    "keep": "შეტყობინებების შენახვა",
    "clearTitle": "ჩეთის გასუფთავება",
    "clearConfirm": "გსურთ ამ მოწყობილობიდან ყველა შეტყობინების წაშლა? ეს უკან დაბრუნებადია.",
    "clear": "ჩეთის გასუფთავება",
    "optionSelected": "არჩეული: {{label}}",
    "sendingSelection": "გაგზავნა...",
    "connectionLost": "კავშირის აღდგენა..."
  },
  "reminders": {
    "title": "ჩემი შეხსენებები",
    "active": "აქტიური",
    "today": "დღეს",
    "thisWeek": "ამ კვირაში",
    "history": "ისტორია",
    "items": "ელემენტები",
    "emptyTitle": "ჯერ არ არის შეხსენებები",
    "emptySubtitle": "შექმენით ერთი ჩეთიდან და აქ გამოჩნდება.",
    "emptyAction": "ჩეთის გახსნა",
    "filterActive": "აქტიური",
    "filterToday": "დღეს",
    "filterWeek": "ამ კვირაში",
    "filterHistory": "ისტორია",
    "emptyState": "ჯერ არ არის შეხსენებები. დაიწყეთ ჩეთი!",
    "swipeDone": "მზად",
    "swipeSnooze": "გადავადება",
    "swipeDelete": "წაშლა",
    "search": "შეხსენებების ძიება...",
    "upcoming": "მომავალი",
    "completed": "დასრულებული",
    "overdue": "ვადაგასული",
    "tomorrow": "ხვალ",
    "synced": "სინქრონიზებულია {{value}}",
    "swipeHint": "გაასრიალეთ შეხსენება მეტი მოქმედებისთვის",
    "noResults": "შეხსენებები არ შეესაბამება ძიებას",
    "noResultsHint": "სცადეთ სხვა სიტყვა ან წაშალეთ ძიება",
    "deleteAllFailed": "ყველა შეხსენების წაშლა ვერ მოხერხდა"
  },
  "calendar": {
    "title": "კალენდარი",
    "today": "დღეს",
    "tomorrow": "ხვალ",
    "completed": "დასრულებული",
    "noEvents": "არ არის დაგეგმილი",
    "noEventsSubtitle": "აირჩიეთ თარიღი, რომ ნახოთ შეხსენებები და კალენდრის მოვლენები.",
    "googleEvent": "Google Calendar",
    "legendActive": "აქტიური",
    "legendRecurring": "გაიმეორებადი",
    "legendDone": "დასრულებული",
    "legendGoogle": "Google",
    "previousMonth": "წინა თვე",
    "nextMonth": "შემდეგი თვე",
    "previousYear": "წინა წელი",
    "nextYear": "შემდეგი წელი",
    "goToToday": "გადადი დღეს",
    "all": "ყველა",
    "active": "აქტიური",
    "done": "დასრულებული",
    "paused": "შეჩერებული"
  },
  "settings": {
    "title": "პარამეტრები",
    "profile": "პროფილი",
    "name": "სახელი",
    "enterName": "შეიყვანეთ სახელი",
    "language": "ენა",
    "uiLanguage": "აპლიკაციის ენა",
    "uiLanguageHelp": "ცვლის აპლიკაციის ინტერფეისს, კალენდრის წარწერებს და განლაგებას მხოლოდ ამ მოწყობილობაზე.",
    "serverLanguage": "ჩეთის ენა",
    "serverLanguageHelp": "ცვლის ენის პარამეტრებს, რომელიც გამოიყენება სერვერის პასუხებში და შეხსენებების შეტყობინებებში.",
    "timezone": "საათის სარტყელი",
    "currentTimezone": "მიმდინარე სარტყელი",
    "timezoneHelp": "ყველა შეხსენების დრო ამ სარტყელის მიხედვით არის ნაჩვენები.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "საათის სარტყელის შენახვა",
    "timezoneSaved": "საათის სარტყელი განახლებულია",
    "detect": "დეტექტირება",
    "detectFailed": "საათის სარტყელის დადგენა ვერ მოხერხდა",
    "autoDetect": "ავტომატურად GPS-დან",
    "notifications": "შეტყობინებები",
    "notificationsHelp": "გაგრძელებული შეხსენებები აკონტროლებენ განმეორებით შეტყობინებებს შეხსენების მიწოდების შემდეგ. მოწყობილობის ნებართვები მართება ტელეფონის პარამეტრებში.",
    "pushEnabled": "შეტყობინებების ჩართვა",
    "autoDoneOnFire": "ავტომატურად მონიშნოს შესრულებულად",
    "autoDoneOnFireDesc": "თუ გამორთულია, შეხსენებები რჩება აქტიური, სანამ თქვენ არ მონიშნავთ დასრულებულად.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "დაკავშირებულია",
    "googleDisconnected": "არ არის დაკავშირებული",
    "googleConnectedHelp": "ახალი შეხსენებები ავტომატურად სინქრონიზირდება კალენდართან.",
    "googleDisconnectedHelp": "დაკავშირეთ Google Calendar, რომ შეხსენებები და მოვლენები სინქრონიზებული იყოს.",
    "googleConnectFailed": "Google Calendar-ის დაკავშირება ვერ მოხერხდა",
    "connected": "დაკავშირებულია",
    "disconnected": "არ არის დაკავშირებული",
    "connect": "დაკავშირება",
    "disconnect": "განკავშირება",
    "autoSync": "ახალი შეხსენებების ავტომატური სინქრონიზაცია",
    "autosync": "ახალი შეხსენებების ავტომატური სინქრონიზაცია",
    "subscription": "abonementi",
    "trialUsed": "ტესტი: {{used}}/{{total}} გამოყენებულია",
    "trialStatus": "ტესტი ხელმისაწვდომია",
    "activeStatus": "აქტიური გამოწერა",
    "expiredStatus": "გამოწერა დასრულებულია",
    "unsubscribedStatus": "არ არის გამოწერილი",
    "about": "შესახებ",
    "version": "ვერსია",
    "logout": "გამოსვლა",
    "logoutTitle": "გამოსვლა",
    "logoutConfirm": "დარწმუნებული ხართ, რომ გინდათ გამოსვლა?",
    "noName": "სახელი არ არის მითითებული",
    "serverConnection": "სერვერის კავშირი",
    "serverUrl": "სერვერის URL",
    "serverEdit": "რედაქტირება",
    "saveReconnect": "შენახვა და ხელახლა დაკავშირება",
    "resetDefault": "დაფიქსირება ნაგულისხმევზე",
    "invalidServerUrlTitle": "არასწორი სერვერის URL",
    "invalidServerUrlMessage": "შეიყვანეთ ვალიდური http ან https სერვერის URL, მაგალითად https://example.com",
    "uiLanguageChangeFailed": "აპლიკაციის ენის შეცვლა ვერ მოხერხდა. გთხოვთ, სცადეთ ისევ.",
    "serverLanguageChangeFailed": "ჩეთის ენის შეცვლა ვერ მოხერხდა. გთხოვთ, სცადეთ ისევ.",
    "timezoneChangeFailed": "საათის სარტყელის შეცვლა ვერ მოხერხდა. გთხოვთ, სცადეთ ისევ.",
    "autoSyncChangeFailed": "ავტომატური სინქრონიზაციის განახლება ვერ მოხერხდა. გთხოვთ, სცადეთ ისევ.",
    "nameChangeFailed": "გამოსახულ სახელს ვერ განაახლებს. გთხოვთ, სცადეთ ისევ.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "შეხსენების დეტალები",
    "editTime": "დროის რედაქტირება",
    "rename": "სახელის შეცვლა",
    "snooze": "გადავადება",
    "snooze15": "გადავადება 15 წუთით",
    "pause": "შეჩერება",
    "pauseReminder": "შეხსენების შეჩერება",
    "resume": "გაგრძელება",
    "resumeReminder": "შეხსენების გაგრძელება",
    "skip": "შემდეგის გამოტოვება",
    "skipOccurrence": "ამ შემთხვევის გამოტოვება",
    "syncGoogle": "სინქრონიზაცია Google-ში",
    "delete": "წაშლა",
    "deleteTitle": "შეხსენების წაშლა",
    "deleteConfirm": "ეს შეხსენება მუდმივად წაიშლება.",
    "deleteRecurringTitle": "გაიმეორებადი შეხსენების წაშლა",
    "deleteRecurringMessage": "გსურთ ამ შემთხვევის გამოტოვება თუ მთელი სერიის წაშლა?",
    "deleteThisOccurrence": "ამ შემთხვევის გამოტოვება",
    "deleteEntireSeries": "სრული სერიის წაშლა",
    "done": "მზად",
    "markDone": "მონიშვნა შესრულებულად",
    "undo": "აღდგენა",
    "undoPrompt": "გინდათ ისევ აქტიური იყოს? აღადგინეთ ახლა.",
    "recurring": "გაიმეორებადი",
    "nextRun": "შემდეგი შესრულება",
    "oneTime": "ერთჯერადი",
    "pending": "მოლოდინში",
    "sent": "გაგზავნილია",
    "paused": "შეჩერებულია",
    "active": "აქტიური",
    "snoozed": "გადავადებულია",
    "localTime": "ნაჩვენებია თქვენი ადგილობრივი დროით",
    "recurrence": "გაიმეორება",
    "created": "შექმნილია",
    "tags": "ტეგები",
    "fireCount": "გაშვების რაოდენობა",
    "actions": "მოქმედებები",
    "none": "არაფერი",
    "snoozeFailed": "შეხსენების გადავადება ვერ მოხერხდა",
    "pauseFailed": "შეხსენების შეჩერება ვერ მოხერხდა",
    "resumeFailed": "შეხსენების გაგრძელება ვერ მოხერხდა",
    "skipFailed": "შეხსენების გამოტოვება ვერ მოხერხდა",
    "doneFailed": "შეხსენების მონიშვნა შესრულებულად ვერ მოხერხდა",
    "undoFailed": "შეხსენების სტატუსის აღდგენა ვერ მოხერხდა",
    "deleteFailed": "შეხსენების წაშლა ვერ მოხერხდა",
    "rescheduleTitle": "გადაწესება?",
    "rescheduleMsg": "ეს შეხსენება ვადაგასულია. გსურთ გადადოთ?",
    "reschedule15": "15 წუთში",
    "reschedule60": "1 საათში",
    "keepOverdue": "დარჩეს როგორც არის"
  },
  "onboarding": {
    "slide1Title": "კეთილი იყოს თქვენი მობრძანება FishMemory-ში",
    "slide1Sub": "თქვენი პირადი შეხსენების ასისტენტი — WhatsApp-ის მხარდაჭერით და ჯიბისთვის შექმნილი.",
    "slide2Title": "უბრალოდ ჩათში დაწერეთ",
    "slide2Sub": "დაწერეთ შეხსენებები ისე, როგორც ფიქრობთ: „გახსენე ხვალ 15:00 საათზე დედას დავურეკო“ — დანარჩენს ჩვენ მოვაგვარებთ.",
    "slide3Title": "არასდროს გამოტოვოთ არაფერი",
    "slide3Sub": "მიიღეთ დროული შეტყობინებები, ორგანიზება ტეგებით და იყავით ყველაფრის სათავეში.",
    "getStarted": "დაწყება",
    "next": "შემდეგი",
    "firstReminderTitle": "შექმენით პირველი შეხსენება!",
    "firstReminderHint": "სცადეთ დაწეროთ რამე მსგავსი:",
    "firstReminderExample": "გახსენე ხვალ 9:00 საათზე წყლის დალევა",
    "gotIt": "გასაგებია!",
    "notifRationaleTitle": "დარჩით დროზე",
    "notifRationaleBody": "FishMemory-ს სჭირდება შეტყობინებები, რომ დროულად შეგახსენოთ. შეტყობინებებს მიიღებთ მხოლოდ თქვენ მიერ შექმნილ შეხსენებებზე.",
    "notifRationaleAllow": "შეტყობინებების ჩართვა",
    "notifRationaleLater": "შეიძლება მოგვიანებით",
    "swipeHint": "გაასრიალეთ მარჯვნივ სწრაფი მოქმედებებისთვის →",
    "calendarDragHint": "გადაათრიეთ გასაფართოებლად ↕"
  }
}
